import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { CategoryAddSchema } from "../../../ValidationSchema";

const CategoryEdit = () => {
  const location = useLocation();
  const Navigate = useNavigate();

  const [initialValues, setInitialValues] = useState({
    name: "", // ✅ use only `name`
  });

  const GetUserData = () => {
    axios
      .get(
        `${process.env.REACT_APP_URL}/admin/category/${location?.state?.id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("Token")}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setInitialValues({
            name: res?.data?.data?.product_category_name || "",
          });
        }
      })
      .catch((err) => {
        const MSG = ["Token not found.", "Invalid token.", "Unauthorized."];
        const STATUS = [401, 403];
        if (
          STATUS.includes(err?.response?.status) ||
          MSG.includes(err?.response?.data?.msg)
        ) {
          localStorage.clear();
          Navigate("/admin/login");
        } else {
          toast.error(err?.response?.data?.msg);
        }
      });
  };

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: CategoryAddSchema,
    onSubmit: (values) => {
      const formData = {
        product_category_name: values.name,
      };

      axios
        .put(
          `${process.env.REACT_APP_URL}/admin/category/${location?.state?.id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            toast.success(`Category Updated Successfully`);
            Navigate("/admin/category");
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data?.message || "Failed to update");
        });
    },
  });

  useEffect(() => {
    if (location?.state?.id) GetUserData();
  }, [location?.state?.id]);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Edit Category</h1>
          <p className="al-sub">Update this product category.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg></div>
            <h3 className="al-cardhead__title">Category Details</h3>
          </div>
          <div className="al-form">
            <div className="al-form__full">
              <label className="al-label">Name <span className="al-req">*</span></label>
              <input className="al-input" type="text" placeholder="Enter Name" {...formik.getFieldProps("name")} />
              {formik.errors.name && formik.touched.name ? (
                <div className="al-err">{formik.errors.name}</div>
              ) : null}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
              Save Changes
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CategoryEdit;
